import Vue from 'vue'
import Vuex from 'vuex'

import * as actions from './actions'
import * as getters from './getters'
import mutations from './mutations'
import state from './state'

import modulesCommon from './modules/common.js'
import modulesInvoice from './modules/invoice.js'


import vuexI18n from 'vuex-i18n'

// 开发模式下使用日志，和谷歌浏览器里面的vuedevtool插件类似
// 子修改state的时候会在控制台打印一些信息
import createLogger from 'vuex/dist/logger'
import {getBrowserLanguage} from './../common/js/common'

Vue.use(Vuex)

// 调试,开发模式开启严格模式，要使用mutations提交
var debug = process.env.NODE_ENV !== 'production'

var store = new Vuex.Store({
  modules: {
    i18n: vuexI18n.store,
    common:modulesCommon,
    invoice:modulesInvoice,
  },

  actions,
  getters,
  state,
  mutations,
  strict: debug,
  plugins: debug ? [createLogger()] : []
})

Vue.use(vuexI18n.plugin, store);


import en_translations from './../common/i18n/en.js'
import zh_cn_translations from './../common/i18n/zh-CN.js'

// 将语言包加入项目   多语言设置
Vue.i18n.add('en',  en_translations);
Vue.i18n.add('zh-CN', zh_cn_translations);
// 设置语言包  TODO...根据客户端语言环境，自动变更语言包
Vue.i18n.set(getBrowserLanguage());

// Vue.i18n.set('en');

// alert(getBrowserLanguage())

export default store






//多语言设置
// var vuxLocales = require('json!yaml!vux/src/locales/all.yml')
// var componentsLocales = require('json!yaml!src/locales/components.yml')
// var globalLocales = require('json!yaml!src/locales/global_locales.yml') || {en: {}, 'zh-CN': {}}

// var finalLocales = {
//   'en': objectAssign(vuxLocales['en'], componentsLocales['en'], globalLocales['en']),
//   'zh-CN': objectAssign(vuxLocales['zh-CN'], componentsLocales['zh-CN'], globalLocales['zh-CN'])
// }

// for (let i in finalLocales) {
//   Vue.i18n.add(i, finalLocales[i])
// }
// Vue.i18n.set('zh-CN')
